import { z } from 'zod'

import { WebPushConsent } from 'common/core/interfaces/userConsent'

export const WebPushConsentSchema: z.ZodType<WebPushConsent> = z.enum([
  'subscribed',
  'unsubscribed',
  'undefined',
])

export const UpdateWebPushConsentSchema = z.object({
  web_push_consent: WebPushConsentSchema.optional(),
})
